import React from "react"
import classnames from "classnames"

import Divider from "./../../widgets/divider"

const GoogleSSOContainer = ({ errors }) => {

  return (
    <>
      {
        ALLOW_SIGN_UP && ALLOW_SSO_SIGN_UP
          ?
          <>
            <Divider text={'OR'}/>
            
            <div className="sso_container">
              <div id='g_sso_btn'></div>
              <label
                className={classnames(
                  errors["g_sso"] !== undefined
                    ? "d-block error-message"
                    : "d-none"
                )}
              >
                {errors["g_sso"]}
              </label>
            </div>
          </>
          :
          null
      }
    </>
  )
}

export default GoogleSSOContainer